/** Application branding — edit these values to change name/logo site-wide. */
export const APP_NAME = import.meta.env.VITE_APP_NAME ?? "I'm Hungry Forms";

export const PRODUCT_NAME = APP_NAME;

export const LOGO_PATH = '/app-logo.png';
export const LOGO_WIDTH = 653;
export const LOGO_HEIGHT = 382;

/** I'm Hungry teal palette — primary for CTAs, secondary for dark chrome. */
export const BRAND_PRIMARY = '#356489';
export const BRAND_SECONDARY = '#094152';
